import { userActionTypes } from "./jobTypes";

const INITIAL_STATE = {
  jobs: [],
};

const jobReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userActionTypes.SET_ALL_JOBS:
      return {
        ...state,
        jobs: action.payload,
      };
    default:
      return state;
  }
};

export default jobReducer;
